import {EventEmitter, Injectable} from '@angular/core';
import { Subject } from 'rxjs';
import {Upload} from '../models/upload.model';

export interface UploadDescription {
    type: string;
    id: number;
    description?: string;
}

@Injectable({providedIn: 'root'})
export class UploadService {

    uploadProcessEmitter = new EventEmitter<UploadDescription>();

    uploadSub = new Subject<Upload>();

    constructor() {
    }

}



